import { renderApp } from '@crow/service-kit/web/app';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { appRoutes } from '@/app-routes';
import { installGlobalDictation } from '@/features/dictation/global-dictation';
import { registerServiceWorker } from '@/lib/pwa';
import { SIGNIN_PAGE } from '@/lib/sign-out';
import { installAppRouter } from '@/vite/navigation-store';
import '@/app/globals.css';

/**
 * The renderer, in every host: a browser, the Desktop's window (the local server's origin), the
 * preview. React Router owns the address (`app-routes.tsx`); the service kit starts it, with the
 * shared query client (an ended session signs in again at `/sign-in`, then comes back).
 */
const router = createBrowserRouter(appRoutes);
installAppRouter(router);

// Not in the Desktop's window (`pwa.ts`).
registerServiceWorker();

// Dictate answers from any app as soon as the Desktop's window is open.
if (window.location.pathname !== '/picture-in-picture') installGlobalDictation();
// The app shows its own toasts (`AppToaster`).
await renderApp(<RouterProvider router={router} />, {
  browserRouter: false,
  toasts: false,
  signinPage: SIGNIN_PAGE,
});
